import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    parentStoreId: null,
    storeId: null,
    store: false,
    categoryId: null,
    stores: [],
    categories: [],
    products: [],
    cartProducts: [],
    cartId: null,
    ordersUpdates: 0,
    recieptsUpdates: 0,
    cartUpdates: 0,
    order: null,
    orders: [],
    paymentMethods: ['ecocash'],
    token: localStorage.getItem('user-token') || '',
    status: '',
  },
  getters,
  mutations,
  actions
})